export default __webpack_public_path__ + "static/media/plus-icon.52db3332.svg";